import { groupBy, orderBy } from "lodash";
import { Item__Atividades, Item__UnidadeMedida, ItemPropriedades } from "../../../../../../../../../services/atividades/GET";
import { dummy_tipos_uso, extrairUnidade } from "../../../../../../linhaDoTempo/components/cadastro/components/addInsumo/meta";
import { Item__EquipeCliente } from "../../../../../../../../../services/Equipe/GET";
import { normarlizarEmKg, obterCodInsumoDashboard, obterNomeMediaLocal } from "../../../../insumosPrecisao/meta";


export function obterInsumoPorTalhao(todas_atividades_ativas: Item__Atividades[], cod_insumo: number, data_propriedades: ItemPropriedades[], tipo_fisico: string) {

    //@ts-ignore
    const talhoes = (data_propriedades ?? []).map(i => i.talhao)?.flat();

    const incluir_tipo_atv = (todas_atividades_ativas ?? []).map(i => {
        return {
            ...i,
            andamentos: (i.andamentos ?? []).map(j => {
                return {
                    ...j, insumos: (j.insumos ?? []).map(k => {
                        return {
                            ...k,
                            tipo_atividade: i.cod_tipo === 1 ? "planejada" : "executada",
                            cod_tipo_atividade: i.cod_tipo,
                            nome_medida_filtro: obterNomeMediaLocal(k.cod_medida).nome_filtro,
                            tipo_fisico_medida: obterNomeMediaLocal(k.cod_medida).tipo_fisico,
                            cod_insumo: obterCodInsumoDashboard(k),
                            quantidade_normalizada: normarlizarEmKg(k.quantidade, k.cod_medida)
                        }
                    }).filter(insumo => String(insumo.tipo_fisico_medida)?.toLowerCase() === String(tipo_fisico)?.toLowerCase())?.filter(i => i.cod_tipo === 8)
                }
            })
        }
    }).filter(i => i.delete_time === null);

    const apenas_atvs_com_insumo_selecionado = incluir_tipo_atv.map(atividade => {
        return {
            ...atividade,
            andamentos: atividade.andamentos.map(andamento => {
                return { ...andamento, insumos: andamento.insumos.filter(insumo => insumo.cod_insumo === cod_insumo) }
            }).filter(andamento => andamento.insumos.length > 0)
        };
    }).filter(atividade => atividade.andamentos.length > 0);

    const agrupar_por_talhao = groupBy(apenas_atvs_com_insumo_selecionado, 'cod_talhao');

    const estrutura_accordion = Object.entries(agrupar_por_talhao ?? []).map(([cod_talhao, lista_atividades]) => {

        const atvs_planejadas = lista_atividades.filter(i => i.cod_tipo === 1);
        const atvs_executadas = lista_atividades.filter(i => i.cod_tipo === 2);


        function obterQtdInoculante(tipo_atv: 'planejada' | 'executada') {
            const atividades_calcular = tipo_atv === 'planejada' ? atvs_planejadas : atvs_executadas;
            //@ts-ignore
            const apenas_insumos_da_atv = atividades_calcular?.map(i => i.andamentos)?.flat().map(j => j.insumos).flat();
            function normalizarQuantidade(medida: string, quantidade_inoculante: number) {
                const deveConverter =
                    (tipo_fisico === 'Líquido' && medida === 'ml') ||
                    (tipo_fisico === 'Sólido' && medida === 'g');

                return deveConverter ? quantidade_inoculante / 1000 : quantidade_inoculante;
            }
            const estrutura_calculo = apenas_insumos_da_atv.map(i => {
                const medida = String(extrairUnidade(i.calculo_dosagem)).toLowerCase();
                return {
                    quantidade_normalizada: normalizarQuantidade(medida, i.quantidade),
                    quantidade: i.quantidade,
                }
            });
            return estrutura_calculo?.reduce((acc, item) => acc + item.quantidade_normalizada, 0);
        }

        let precisao = 0;
        let porcentagem = 0;
        const quantidade_planejada = obterQtdInoculante('planejada');
        const quantidade_executada = obterQtdInoculante('executada');

        if (quantidade_planejada > 0) {
            const porcentagem_realizada = (quantidade_executada / quantidade_planejada) * 100;
            precisao = 100 - Math.abs(100 - porcentagem_realizada);
            if (precisao < 0) precisao = 0;
            porcentagem = porcentagem_realizada;
        } else if (quantidade_executada > 0) {
            precisao = 0;
            porcentagem = 0;
        }

        return {
            cod_talhao: Number(cod_talhao),
            nome_talhao: talhoes.find(i => i.cod === Number(cod_talhao))?.nome,
            nome_propriedade: data_propriedades.find(i => i.cod === Number(lista_atividades?.[0]?.cod_propriedade))?.nome,
            atvs_planejadas: atvs_planejadas,
            atvs_executadas: atvs_executadas,
            quantidade_planejada,
            quantidade_executada,
            precisao,
            porcentagem,
            tipo_fisico,
            calculo_dosagem: lista_atividades?.[0]?.andamentos?.[0]?.insumos?.[0]?.calculo_dosagem,
        }
    })

    return orderBy(estrutura_accordion, ['nome_propriedade', 'quantidade_executada', 'quantidade_planejada'], ['asc', 'desc', 'desc']) ?? [];
};





export function estruturaListarInsumos(
    atividades_com_o_insumo: any[],
    data_unidades_medida: any[],
    // data_unidades_medida: Item__UnidadeMedida[],
    data_equipe_cliente: Item__EquipeCliente[],
    todas_atividades_ativas: Item__Atividades[],
    tipo_fisico: string,
) {

    function obterNomeAtvPlanejada(cod_atividade_planejada: number) {
        const atv = todas_atividades_ativas.find(i => i.cod === cod_atividade_planejada);
        return atv?.descricao;
    }

    const add_info_atv = atividades_com_o_insumo.map(i => {
        return {
            ...i,
            andamentos: i.andamentos.map(j => {
                return {
                    ...j,
                    insumos: j.insumos.map(k => {
                        function obterNomeOperador(cod_usuario: number | null): string | null {
                            const operador = (data_equipe_cliente ?? []).find(eq => eq?.cod_func === cod_usuario);
                            return operador ? operador.usuario_nome ?? null : null;
                        }
                        function normalizarQuantidade(medida: string, quantidade_inoculante: number) {
                            const deveConverter =
                                (tipo_fisico === 'Líquido' && medida === 'ml') ||
                                (tipo_fisico === 'Sólido' && medida === 'g');

                            return deveConverter ? quantidade_inoculante / 1000 : quantidade_inoculante;
                        }
                        return {
                            ...k,
                            area: j.area,
                            cod_tipo_atividade: i.cod_tipo,
                            nome_atividade: i.cod_tipo === 1 ? i.descricao : obterNomeAtvPlanejada(i.cod_atividade),
                            operadores_atv: obterNomeOperador(j.cod_usuario),
                            data_atv_inicio: i.data_inicio,
                            data_atv_fim: i.data_fim,
                            tipo_uso_nome: dummy_tipos_uso.find(t => t.cod === k.cod_tipo)?.nome,
                            quantidade_normalizada: normalizarQuantidade(String(extrairUnidade(k.calculo_dosagem)).toLowerCase(), k.quantidade),
                            nome_medida: data_unidades_medida.find(t => t.cod === k.cod_medida)?.nome,
                            medida_dosagem: String(extrairUnidade(k.calculo_dosagem)),
                        }
                    })
                }
            })
        }
    });

    //@ts-ignore
    const apenas_insumos = add_info_atv.map(i => i.andamentos.map(j => j.insumos)).flat(2);

    return orderBy(apenas_insumos, ['data_atv_inicio'], ['asc']) ?? [];
}
